import React, {useState, useEffect} from 'react';
import {getCertificate, getUserCertificates} from 'crypto-pro-actual-cades-plugin';
import {Alert, Col, Collapse, Row, Select} from "antd";
import moment from "moment/moment";
import Spinner from "../../../spinner";
import i18n from "../../../../i18n";

function Certificate({onChange}) {
  const [certificates, setCertificates] = useState([]);
  const [certificatesError, setCertificatesError] = useState([]);
  const [certificate, setCertificate] = useState(null);
  const [certificateDetails, setCertificateDetails] = useState(null);
  const [detailsError, setDetailsError] = useState(null);
  const [loading, setLoading] = useState(false);

  function selectCertificate(value) {
    const certificate = certificates.find(({thumbprint}) => thumbprint === value);

    setCertificate(certificate);
    onChange(certificate);
  }

  async function loadCertificateDetails(thumbprint) {
    try {
      const certificate = await getCertificate(thumbprint);

      setCertificateDetails({
        name: certificate.name,
        issuerName: certificate.issuerName,
        subjectName: certificate.subjectName,
        thumbprint: certificate.thumbprint,
        validFrom: certificate.validFrom,
        validTo: certificate.validTo,
        isValid: await certificate.isValid(),
        version: await certificate.getCadesProp('Version'),
        base64: await certificate.exportBase64(),
        algorithm: await certificate.getAlgorithm(),
        extendedKeyUsage: await certificate.getExtendedKeyUsage(),
        ownerInfo: await certificate.getOwnerInfo(),
        issuerInfo: await certificate.getIssuerInfo(),
        decodedExtendedKeyUsage: await certificate.getDecodedExtendedKeyUsage(),
        '1.3.6.1.4.1.311.80.1': await certificate.hasExtendedKeyUsage('1.3.6.1.4.1.311.80.1'),
        '[\'1.3.6.1.5.5.7.3.2\', \'1.3.6.1.4.1.311.10.3.12\']': await certificate.hasExtendedKeyUsage([
          '1.3.6.1.5.5.7.3.2',
          '1.3.6.1.4.1.311.10.3.12'
        ]),
        '1.3.6.1.4.1.311.80.2': await certificate.hasExtendedKeyUsage('1.3.6.1.4.1.311.80.2'),
        '\'1.3.6.1.5.5.7.3.3\', \'1.3.6.1.4.1.311.10.3.12\'': await certificate.hasExtendedKeyUsage([
          '1.3.6.1.5.5.7.3.3',
          '1.3.6.1.4.1.311.10.3.12'
        ]),
      });
    } catch (error) {
      setDetailsError(error);
    }
  }

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        setCertificates(await getUserCertificates());
        setLoading(false);
      } catch (error) {
        setCertificatesError(error.message);
        setLoading(false);
      }
    })();
  }, []);

  const {Option} = Select;
  const {Panel} = Collapse;
  return (
    <Spinner loading={loading} label={i18n.t('modals.certificate.loading')} >
      {certificatesError && certificatesError.length > 0 &&
        <Alert type="error" message={<div>
          {certificatesError}
          <div style={{marginTop: 20}}>
            <ol>
              <li>{i18n.t('modals.modalLoginApiCompany.errorMessage.1')} <a
                  href='https://www.cryptopro.ru/sites/default/files/products/cades/demopage/cades_bes_sample.html'
                  style={{
                    fontWeight: "bold",
                    color: "green",
                    textDecoration: "underline"
                  }}
                > {i18n.t('modals.modalLoginApiCompany.errorMessage.2')}</a> {i18n.t('modals.modalLoginApiCompany.errorMessage.3')}
              </li>
              <li>{i18n.t('modals.modalLoginApiCompany.errorMessage.4')} <a style={{
                  fontWeight: "bold",
                  color: "green",
                  textDecoration: "underline"
                }}
                   href='https://docs.cryptopro.ru/cades/plugin/plugin-installation-windows'> {i18n.t('modals.modalLoginApiCompany.errorMessage.5')}</a>
              </li>
              <li>{i18n.t('modals.modalLoginApiCompany.errorMessage.6')}</li>
            </ol>
          </div>
        </div>
        } banner/>
      }
      {certificates.length > 0 &&
        <>
          <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
            <Col span={24}>
              <Select id="certificate" defaultValue={null} onChange={selectCertificate} style={{width: "100%"}}
                      className={"astral"}>
                {certificates.map(({name, thumbprint, validTo}) =>
                  <Option key={thumbprint} value={thumbprint} style={{width: "100%"}}>
                    {i18n.t('modals.certificate.description', {name:name, date: moment(validTo).format("DD.MM.YYYY")})}
                  </Option>
                )}
              </Select>
              <pre>{certificatesError || null}</pre>
            </Col>
          </Row>
          <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
            <Col span={24}>
              {certificate ? (
                <>
                  <Collapse onChange={() => loadCertificateDetails(certificate.thumbprint)}>
                    <Panel header={i18n.t('modals.certificate.info')} key="1">
                <pre>
              {certificateDetails ? (
                JSON.stringify(certificateDetails, null, '  ')
              ) : i18n.t('modals.certificate.pending')}
            </pre>
                      <pre>{detailsError || null}</pre>
                    </Panel>
                  </Collapse>

                </>
              ) : null}
            </Col>
          </Row>
        </>
      }
    </Spinner>
  );
}

export default Certificate;
